'use strict'

/**
 * Хранилище всех имен view, доступных для роутинга
 */

export const VIEWS = {
  login: createView('login', 'Login'),
  error: createView('error', 'Error'),
  table: {
    index: createView('table', 'TableIndex'),
    settings: createView('table', 'TableSettings'),
    queue: createView('table', 'TableQueue'),
    custom: {
      raif: {
        queue: createView('table', 'RaifTableQueue')
      },
      doubleStatus: createView('table', 'DoubleStatusTableQueue')
    }
  }

}

function createView (type, name) {
  return {
    moduleType: type,
    name: name
  }
}
